export interface FileUploadTextConfig {
  fileFormatErrorText: string;
  fileSizeErrorText: string;
  uploadingText: string;
  dragandDropText: string;
  tableFileText: string;
  tableStatusText: string;
  tableActionText: string;
  uploadingActionText: string;
  uploadInProgressText?: string;
  uploadSuccessText?: string;
  replaceSuccessText?: string;
}

export type Status = 'Removed' | 'Success' | 'Failed' | 'Uploading';

export interface FilesStateConfig {
  fileObject: [string, File];
  content: string;
  status: Status;
  fieldId: string;
  statusText: string;
  fileSizeExceeded: boolean;
  fileFormatError: boolean;
  action: string;
  actionText: string;
  userAction: string;
  preventDelete?: boolean;
}

export interface FileUploadProgressStream {
  fileObject: [string, File];
  fileId: string;
  content: string;
  file: string;
  status: Status;
  statusText: string;
  action: string;
  actionText: string;
  userAction: string;
  preventDelete?: boolean;
}

export const defaultTextConfig: FileUploadTextConfig = {
  fileFormatErrorText: 'Failed, file format error',
  fileSizeErrorText: 'Error, file size exceeded. (Max. 10MB)',
  uploadingText: 'Uploading...',
  dragandDropText: 'Drop files here.',
  tableFileText: 'File Name',
  tableStatusText: 'Status',
  tableActionText: 'Action',
  uploadingActionText: 'Cancel',
  uploadInProgressText: 'upload is in progress',
  uploadSuccessText: 'uploaded successfully',
  replaceSuccessText: 'replaced successfully'
};

export type UploadFileConfig = Omit<FilesStateConfig, 'content' | 'userAction' | 'preventDelete'>;

export type FileUploadStatus = 'success' | 'error' | undefined;

export type FileUploadFeedback = 'tabular' | 'compact' | 'preview';

export type FileUploadType = 'button' | undefined;
